import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseCircled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "close-circle-line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9.99996 18.3334C5.39758 18.3334 1.66663 14.6024 1.66663 10C1.66663 5.39765 5.39758 1.66669 9.99996 1.66669C14.6023 1.66669 18.3333 5.39765 18.3333 10C18.3333 14.6024 14.6023 18.3334 9.99996 18.3334ZM9.99996 16.6667C13.6819 16.6667 16.6666 13.6819 16.6666 10C16.6666 6.31812 13.6819 3.33335 9.99996 3.33335C6.31806 3.33335 3.33329 6.31812 3.33329 10C3.33329 13.6819 6.31806 16.6667 9.99996 16.6667ZM9.99996 8.82152L12.357 6.46449L13.5355 7.64299L11.1785 10L13.5355 12.357L12.357 13.5355L9.99996 11.1785L7.64293 13.5355L6.46443 12.357L8.82146 10L6.46443 7.64299L7.64293 6.46449L9.99996 8.82152Z",
			fill: "#8590A2",
			fillOpacity: .5
		})
	})
});
export default SvgCloseCircled;
